var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"card card-with-shadow border-0",staticStyle:{"min-height":"400px"}},[_c('div',{staticClass:"card-body p-primary"},[_c('app-calendar',{attrs:{"preloader":_vm.preloader,"options":_vm.options}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }